module.exports = __webpack_public_path__ + "static/ph-logo-8c1ff35a447588ca183138b5b9ab2024.png";